import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InstantFeedbackApiService } from '@app/core/service/api/instantFeedback.api.service';
import { IonicModule } from '@ionic/angular';
import { DirectivesModule } from '../directives.module';
import { InstantFeedbackButtonComponent } from './instant-feedback-button.component';

@NgModule({
  imports: [CommonModule, IonicModule, DirectivesModule],
  exports: [InstantFeedbackButtonComponent],
  declarations: [InstantFeedbackButtonComponent],
  providers: [InstantFeedbackApiService]
})
export class InstantFeedbackButtonModule {}
